import { Affix, Flex, Group, Loader } from "@mantine/core";
import { isMobileDevice } from "../../utils/useDeviceDetection";
import React, { useContext } from "react";
import { createPortal } from "react-dom";
import { FooterSlotContext } from "../appWebview/footerSlot";
import classes from "./index.module.css";

export function FooterButtons({
  children,
  isLoading = false,
  app: isApp = false,
}: {
  readonly children: React.ReactNode;
  readonly isLoading?: boolean;
  /** Renders into the app-webview layout's footer bar instead of a fixed affix. */
  readonly app?: boolean;
}) {
  const isMobile = isMobileDevice();
  const isSingle = React.Children.toArray(children).length === 1;
  const slot = useContext(FooterSlotContext);

  // The web's auto side margins would undo the app footer's full-width stretch.
  const groupClassName = isApp
    ? classes["group--app"]
    : [
        classes.group,
        !isMobile &&
          (isSingle ? classes["group--single"] : classes["group--constrained"]),
      ]
        .filter(Boolean)
        .join(" ");

  const content = isLoading ? (
    <Flex justify={"center"}>
      <Loader role="status" aria-label="Laddar innehåll" />
    </Flex>
  ) : (
    // wrap-reverse puts the primary on the line above once the labels stop fitting.
    <Group
      grow={!isApp}
      wrap={isApp ? "wrap-reverse" : "wrap"}
      gap={isMobile || isApp ? "sm" : "md"}
      className={groupClassName}
    >
      {children}
    </Group>
  );

  if (isApp) return slot ? createPortal(content, slot) : null;

  return (
    <Affix
      position={{ bottom: 0 }}
      bg={"white"}
      w={"100vw"}
      p={isMobile ? "md" : "lg"}
    >
      {content}
    </Affix>
  );
}
